import styled from 'styled-components'

export const MinimalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 12px;
  background: #f8f9fa;
  height: 100%;
  overflow-y: auto;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
  }
`

export const UserHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 12px;
`

export const UserAvatar = styled.div<{ $level?: number }>`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: ${props => {
    if (props.$level !== undefined) {
      const hue = (props.$level * 40) % 360
      return `linear-gradient(135deg, hsl(${hue}, 70%, 50%) 0%, hsl(${hue + 30}, 70%, 40%) 100%)`
    }
    return 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' // Default
  }};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-weight: 600;
  flex-shrink: 0;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`

export const LevelBadge = styled.div<{ $level?: number }>`
  position: absolute;
  top: -4px;
  right: -4px;
  background: ${props => {
    if (props.$level !== undefined) {
      const hue = (props.$level * 40) % 360
      return `linear-gradient(135deg, hsl(${hue}, 70%, 50%) 0%, hsl(${hue + 30}, 70%, 40%) 100%)`
    }
    return 'transparent'
  }};
  color: white;
  font-size: 8px;
  font-weight: 600;
  padding: 1px 3px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  z-index: 2;
  min-width: auto;
  text-align: center;
  white-space: nowrap;
  line-height: 1.2;
  display: ${props => props.$level !== undefined ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  
  .anticon {
    font-size: 8px;
    color: white;
  }
`

export const UserBasicInfo = styled.div`
  flex: 1;
  margin-left: 12px;
  
  .name {
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 4px;
  }
  
  .meta {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    
    .divider {
      width: 1px;
      height: 10px;
      background: rgba(0, 0, 0, 0.15);
    }
  }
`

export const ActionButtons = styled.div`
  display: flex;
  gap: 6px;
  
  button {
    padding: 4px 10px;
    font-size: 11px;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: white;
    color: rgba(0, 0, 0, 0.65);
    cursor: pointer;
    transition: all 0.2s;
    
    &:hover {
      background: rgba(0, 0, 0, 0.03);
      border-color: rgba(0, 0, 0, 0.2);
    }
    
    &.edit {
      background: #5c7cfa;
      color: white;
      border-color: #5c7cfa;
      
      &:hover {
        background: #4c6ef5;
      }
    }
  }
`

export const StatsCards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-bottom: 20px;
`

export const StatCard = styled.div`
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  padding: 10px 12px;
  
  .label {
    font-size: 11px;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 4px;
  }
  
  .value {
    font-size: 14px;
    font-weight: 600;
    color: #1a1a1a;
    display: flex;
    align-items: baseline;
    gap: 4px;
    
    .unit {
      font-size: 11px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
    }
  }
  
  &.clickable {
    cursor: pointer;
    transition: all 0.2s;
    
    &:hover {
      background: rgba(92, 124, 250, 0.03);
      border-color: rgba(92, 124, 250, 0.2);
    }
  }
`

export const InfoSection = styled.div`
  padding: 10px;
  margin-bottom: 6px;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  
  &:last-of-type {
    margin-bottom: 0;
  }
`

export const SectionTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  padding-left: 2px;
`

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  min-height: 26px;
  margin-bottom: 5px;
  
  &:last-child {
    margin-bottom: 0;
  }
`

export const InfoLabel = styled.div`
  width: 80px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  flex-shrink: 0;
`

export const InfoValue = styled.div`
  flex: 1;
  font-size: 13px;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  gap: 6px;
  
  input {
    flex: 1;
    padding: 4px 8px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    font-size: 13px;
    background: white;
    transition: all 0.2s;
    
    &:focus {
      outline: none;
      border-color: #5c7cfa;
      box-shadow: 0 0 0 2px rgba(92, 124, 250, 0.1);
    }
    
    &:disabled {
      background: rgba(0, 0, 0, 0.02);
      cursor: not-allowed;
    }
  }
  
  .tag {
    padding: 2px 8px;
    background: rgba(92, 124, 250, 0.08);
    border-radius: 4px;
    font-size: 11px;
    color: #5c7cfa;
    font-weight: 500;
  }
  
  .empty {
    color: rgba(0, 0, 0, 0.25);
    font-style: italic;
  }
`

export const GroupTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  
  .group-tag {
    padding: 3px 8px;
    background: rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    font-size: 11px;
    color: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    gap: 4px;
    
    .anticon {
      font-size: 10px;
      color: rgba(0, 0, 0, 0.35);
    }
  }
`

export const SecurityBadge = styled.div<{ active?: boolean }>`
  padding: 3px 8px;
  background: ${props => props.active ? 'rgba(16, 185, 129, 0.08)' : 'rgba(239, 68, 68, 0.08)'};
  border: 1px solid ${props => props.active ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)'};
  border-radius: 4px;
  font-size: 11px;
  color: ${props => props.active ? '#059669' : '#dc2626'};
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  
  .anticon {
    font-size: 10px;
  }
`

export const CompactMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  margin-top: 12px;
  
  .meta-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    color: rgba(0, 0, 0, 0.45);
    
    .anticon {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.35);
    }
    
    .value {
      color: rgba(0, 0, 0, 0.65);
      font-weight: 500;
    }
  }
`

export const CompactStatsBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  margin-bottom: 8px;
`

export const CompactStatItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #1a1a1a;
  
  .anticon {
    font-size: 14px;
    color: #5c7cfa;
  }
  
  span {
    font-weight: 500;
  }
  
  &.clickable {
    cursor: pointer;
    
    &:hover {
      opacity: 0.7;
    }
  }
`